import { Registry } from '@react-registry'
import { customCodeBlockKeydown, handleExitCodeBlock } from '../../../elements/Element/code/withCustomKeydown'

const codeBlockKeydown = ({ event, editor }) => {
  // Handle Enter key in code blocks
  if (event.key === 'Enter') {
    customCodeBlockKeydown(event, editor)
  }
  
  // Handle Shift+Enter to exit code blocks
  if (event.shiftKey && event.key === 'Enter') {
    handleExitCodeBlock(event, editor)
  }
}

Registry.register(codeBlockKeydown, {
  id: 'code-block-keydown',
  registry: 'keydown'
}) 